import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const EVENT_TYPES_EVENT_TYPE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/event-types',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:EventTypes',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.EventTypes',
      },
    ]);
  };
}
